import Image from "@/components/Image/Image";
import { useIsomorphicLayoutEffect } from "hooks/useIsomorphicLayoutEffect";
import { NewsletterContext } from "pages/newsletter";
import { useContext, useEffect, useState } from "react";

const NewsletterForm = ({ content }) => {
  const { activeStage } = useContext(NewsletterContext);
  const properties =
    content.colPos1[0].content.form.elements[0].elements[0].properties;

  const [imagePath, setImagePath] = useState("");

  useIsomorphicLayoutEffect(() => {
    if (activeStage.length === 0 || activeStage.includes("nfz")) {
      setImagePath(properties.imagePathNFZ);
    } else if (activeStage.includes("pkw") && !activeStage.includes("nfz")) {
      setImagePath(properties.imagePathPkw);
    } else {
      setImagePath(properties.imagePathNFZ);
    }
  }, [activeStage, properties]);
  return (
    <div className={`w-full  h-full flex `}>
      <Image
        src={`${process.env.NEXT_PUBLIC_API_URL}${imagePath}`}
        alt="newsletter image"
        width={744}
        height={600}
        objectFit="cover"
        className="w-full h-full object-cover"
      />
    </div>
  );
};

export default NewsletterForm;
